import {
  ASSETS_ACCOUNTS_RECEIVABLE_ALIAS,
  ASSETS_INTANGIBLES_ALIAS,
  ASSETS_INVENTORY_ALIAS,
  ASSETS_OTHER_CURRENT_ALIAS,
  ASSETS_OTHER_LONG_TERM_ALIAS,
  ASSETS_PPE_ALIAS,
  ASSETS_TOTAL_ALIAS,
  ASSETS_TOTAL_CURRENT_ALIAS,
  ASSETS_TOTAL_LONG_TERM_ALIAS,
  CASH_AND_EQUIVALENTS_ALIAS,
  EQUITY_TOTAL_ALIAS,
  LIABILITIES_ACCOUNT_PAYABLE_ALIAS,
  LIABILITIES_ACCRUED_LIABILITIES_ALIAS,
  LIABILITIES_DEFERRED_REVENUE_ALIAS,
  LIABILITIES_LONG_TERM_DEBT_ALIAS,
  LIABILITIES_OTHER_CURRENT_ALIAS,
  LIABILITIES_OTHER_LONG_TERM_ALIAS,
  LIABILITIES_SHORT_TERM_DEBT_ALIAS,
  LIABILITIES_TOTAL_ALIAS,
  LIABILITIES_TOTAL_CURRENT_ALIAS,
  LIABILITIES_TOTAL_LONG_TERM_ALIAS,
  TOTAL_LIABILITIES_AND_EQUITY_ALIAS,
} from 'common/constants/financials';
import { FinancialStatementPeriod } from 'common/types/financials';
import hasReportedValue from './hasReportedValue';
import trimBlankExportColumns from './trimBlankExportColumns';

// Every value-bearing row of the balance sheet row config, in row order.
// Keep in sync with pages/Financials/balance-sheet/data/rowConfig.
const BALANCE_SHEET_VALUE_ALIASES = [
  CASH_AND_EQUIVALENTS_ALIAS,
  ASSETS_ACCOUNTS_RECEIVABLE_ALIAS,
  ASSETS_INVENTORY_ALIAS,
  ASSETS_OTHER_CURRENT_ALIAS,
  ASSETS_TOTAL_CURRENT_ALIAS,
  ASSETS_PPE_ALIAS,
  ASSETS_INTANGIBLES_ALIAS,
  ASSETS_OTHER_LONG_TERM_ALIAS,
  ASSETS_TOTAL_LONG_TERM_ALIAS,
  ASSETS_TOTAL_ALIAS,
  LIABILITIES_SHORT_TERM_DEBT_ALIAS,
  LIABILITIES_ACCOUNT_PAYABLE_ALIAS,
  LIABILITIES_ACCRUED_LIABILITIES_ALIAS,
  LIABILITIES_DEFERRED_REVENUE_ALIAS,
  LIABILITIES_OTHER_CURRENT_ALIAS,
  LIABILITIES_TOTAL_CURRENT_ALIAS,
  LIABILITIES_LONG_TERM_DEBT_ALIAS,
  LIABILITIES_OTHER_LONG_TERM_ALIAS,
  LIABILITIES_TOTAL_LONG_TERM_ALIAS,
  LIABILITIES_TOTAL_ALIAS,
  EQUITY_TOTAL_ALIAS,
  TOTAL_LIABILITIES_AND_EQUITY_ALIAS,
] as const;

const hasBalanceSheetValue = (column: FinancialStatementPeriod) => {
  const balanceSheet = column.balance_sheet;

  if (!balanceSheet) {
    return false;
  }

  return BALANCE_SHEET_VALUE_ALIASES.some(alias => hasReportedValue(balanceSheet[alias]));
};

/**
 * Trims blank fiscal-year columns off both ends of the balance sheet.
 *
 * Unlike the income statement, historical years are in scope here as well as projections,
 * so leading blanks go too. LTM is never trimmed — it is the "As Of" column the balance
 * sheet exists to report.
 */
const trimBlankBalanceSheetColumns = (columns: FinancialStatementPeriod[]) =>
  trimBlankExportColumns({
    columns,
    hasValue: hasBalanceSheetValue,
    isTrimmable: () => true,
  });

export default trimBlankBalanceSheetColumns;
